export const STATUS_HTTP_VALIDACAO = 422;
export const STATUS_HTTP_OK = 200;
export const STATUS_HTTP_ERRO_INTERNO = 500;
export const STATUS_HTTP_UNAUTHORIZED = 401;
export const STATUS_BASE_EXCEPTION = 501;
export const STATUS_HTTP_FORBIDDEN = 403;
